import { LaunchContextFixture, type BootConfigDefaults } from "@slot/game-shell";

/**
 * What slot-cannon states about its boot (`launchGame`'s defaults); the shell reads the env names and the
 * URL flags itself (`createBootConfig`). The staging backend is the `?backend=staging` target of every
 * build but a `deployed` one, which names its own (`.env.staging`). The offline launch fixture is MOBILE:
 * the e2e desktop project boots with `?device=desktop`.
 */
export const slotCannonBootDefaults: BootConfigDefaults = {
  stagingBackendUrl: "https://slot-backend-cannon-staging.fly.dev",
  launchContextFixture: LaunchContextFixture.Mobile,
  assetsBaseUrl: "./assets",
  denominationFactor: 100,
};
